import { render, staticRenderFns } from "./EmailSent.component.vue?vue&type=template&id=1941c1a0&"
import script from "./EmailSent.component.vue?vue&type=script&lang=ts&"
export * from "./EmailSent.component.vue?vue&type=script&lang=ts&"
import style0 from "./EmailSent.component.vue?vue&type=style&index=0&id=1941c1a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports